import styled from 'styled-components';
import { TrimTitleSectionStyled } from '../TrimTitleSectionStyled';
import { rem } from 'polished';

export const TrimTitleSectionStyledDS = styled(TrimTitleSectionStyled)`
    .title {
        font-size: ${rem(32)};
    }
    .subTitle {
        font-size: ${rem(20)};
    }
    .filter {
        font-size: ${rem(16)};
        padding: ${rem(4)} ${rem(10)};
        color: ${({ theme }) => theme.colors.black};
        width: ${rem(90)};
        border-radius: ${rem(24)};

        .count {
            width: ${rem(20)};
            height: ${rem(20)};
            justify-content: center;
        }

        &:hover,
        &:focus-visible {
            color: ${({ theme }) => theme.colors.primary};
            background: ${({ theme }) => theme.colors.grey4};
            border-color: ${({ theme }) => theme.colors.primary};
        }
    }
`;
